export default __webpack_public_path__ + "static/media/message-tooltip.f159ad8a.svg";